import { render, staticRenderFns } from "./AddDepartement.vue?vue&type=template&id=4599174c"
import script from "./AddDepartement.vue?vue&type=script&lang=js"
export * from "./AddDepartement.vue?vue&type=script&lang=js"
import style0 from "./AddDepartement.vue?vue&type=style&index=0&id=4599174c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports